'use strict';

var _slicedToArray = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _regeneratorRuntime = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _createForOfIteratorHelper = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");

var _asyncToGenerator = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var debug = require('debug');

var errcode = require('err-code');

var log = debug('libp2p:peer-store');
log.error = debug('libp2p:peer-store:error');

var _require = require('./errors'),
    ERR_INVALID_PARAMETERS = _require.ERR_INVALID_PARAMETERS;

var Topology = require('libp2p-interfaces/src/topology');

var _require2 = require('libp2p-interfaces/src/connection'),
    Connection = _require2.Connection;

var PeerInfo = require('peer-info');
/**
 * Responsible for notifying registered protocols of events in the network.
 */


var Registrar = /*#__PURE__*/function () {
  /**
   * @param {Object} props
   * @param {PeerStore} props.peerStore
   * @constructor
   */
  function Registrar(_ref) {
    var peerStore = _ref.peerStore;

    _classCallCheck(this, Registrar);

    this.peerStore = peerStore;
    /**
     * Map of connections per peer
     * TODO: this should be handled by connectionManager
     * @type {Map<string, Array<conn>>}
     */

    this.connections = new Map();
    /**
     * Map of topologies
     *
     * @type {Map<string, object>}
     */

    this.topologies = new Map();
    this._handle = undefined;
  }

  _createClass(Registrar, [{
    key: "close",

    /**
     * Cleans up the registrar
     * @async
     */
    value: function () {
      var _close = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var tasks, _iterator, _step, connectionList, _iterator2, _step2, connection;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                // Close all connections we're tracking
                tasks = [];
                _iterator = _createForOfIteratorHelper(this.connections.values());

                try {
                  for (_iterator.s(); !(_step = _iterator.n()).done;) {
                    connectionList = _step.value;
                    _iterator2 = _createForOfIteratorHelper(connectionList);

                    try {
                      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                        connection = _step2.value;
                        tasks.push(connection.close());
                      }
                    } catch (err) {
                      _iterator2.e(err);
                    } finally {
                      _iterator2.f();
                    }
                  }
                } catch (err) {
                  _iterator.e(err);
                } finally {
                  _iterator.f();
                }

                _context.next = 5;
                return tasks;

              case 5:
                this.connections.clear();

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function close() {
        return _close.apply(this, arguments);
      }

      return close;
    }()
    /**
     * Add a new connected peer to the record
     * TODO: this should live in the ConnectionManager
     * @param {PeerInfo} peerInfo
     * @param {Connection} conn
     * @returns {void}
     */

  }, {
    key: "onConnect",
    value: function onConnect(peerInfo, conn) {
      if (!PeerInfo.isPeerInfo(peerInfo)) {
        throw errcode(new Error('peerInfo must be an instance of peer-info'), ERR_INVALID_PARAMETERS);
      }

      if (!Connection.isConnection(conn)) {
        throw errcode(new Error('conn must be an instance of interface-connection'), ERR_INVALID_PARAMETERS);
      }

      var id = peerInfo.id.toB58String();
      var storedConn = this.connections.get(id);

      if (storedConn) {
        storedConn.push(conn);
      } else {
        this.connections.set(id, [conn]);
      }
    }
    /**
     * Remove a disconnected peer from the record
     * TODO: this should live in the ConnectionManager
     * @param {PeerInfo} peerInfo
     * @param {Connection} connection
     * @param {Error} [error]
     * @returns {void}
     */

  }, {
    key: "onDisconnect",
    value: function onDisconnect(peerInfo, connection, error) {
      if (!PeerInfo.isPeerInfo(peerInfo)) {
        throw errcode(new Error('peerInfo must be an instance of peer-info'), ERR_INVALID_PARAMETERS);
      }

      var id = peerInfo.id.toB58String();
      var storedConn = this.connections.get(id);

      if (storedConn && storedConn.length > 1) {
        storedConn = storedConn.filter(function (conn) {
          return conn.id !== connection.id;
        });
        this.connections.set(id, storedConn);
      } else if (storedConn) {
        var _iterator3 = _createForOfIteratorHelper(this.topologies),
            _step3;

        try {
          for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
            var _step3$value = _slicedToArray(_step3.value, 2),
                topology = _step3$value[1];

            topology.disconnect(peerInfo, error);
          }
        } catch (err) {
          _iterator3.e(err);
        } finally {
          _iterator3.f();
        }

        this.connections.delete(peerInfo.id.toB58String());
      }
    }
    /**
     * Get a connection with a peer.
     * @param {PeerInfo} peerInfo
     * @returns {Connection}
     */

  }, {
    key: "getConnection",
    value: function getConnection(peerInfo) {
      if (!PeerInfo.isPeerInfo(peerInfo)) {
        throw errcode(new Error('peerInfo must be an instance of peer-info'), ERR_INVALID_PARAMETERS);
      }

      var connections = this.connections.get(peerInfo.id.toB58String()); // Return the first, open connection

      if (connections) {
        return connections.find(function (connection) {
          return connection.stat.status === 'open';
        });
      }

      return null;
    }
    /**
     * Register handlers for a set of multicodecs given
     * @param {Topology} topology protocol topology
     * @return {string} registrar identifier
     */

  }, {
    key: "register",
    value: function register(topology) {
      if (!Topology.isTopology(topology)) {
        throw errcode(new Error('topology must be an instance of interfaces/topology'), ERR_INVALID_PARAMETERS);
      } // Create topology


      var id = parseInt(Math.random() * 1e9).toString(36) + Date.now();
      this.topologies.set(id, topology); // Set registrar

      topology.registrar = this;
      return id;
    }
    /**
     * Unregister topology.
     * @param {string} id registrar identifier
     * @return {boolean} unregistered successfully
     */

  }, {
    key: "unregister",
    value: function unregister(id) {
      return this.topologies.delete(id);
    }
  }, {
    key: "handle",
    get: function get() {
      return this._handle;
    },
    set: function set(handle) {
      this._handle = handle;
    }
  }]);

  return Registrar;
}();

module.exports = Registrar;